import { DialogBody } from '@modules/get-slash-internet-card/components/dialog-views/dialog-body';
import { Alert } from '@tuic/web-compositions/core/Alert';
import { Button } from '@tuic/web-compositions/core/Button';
import { ButtonGroup } from '@tuic/web-compositions/core/ButtonGroup';
import { LoadingSpinner } from '@tuic/web-compositions/core/LoadingSpinner';
import { HeaderSection } from '@tuic/web-compositions/shared/HeaderSection';

import type { AlertProps } from '@tuic/web-compositions/core/Alert';
import type { ButtonProps } from '@tuic/web-compositions/core/Button';
import type { FC, ReactNode } from 'react';

type Props = {
  indicating?: boolean;
  connectionTag?: ReactNode;
  progressBar?: ReactNode;
  alert?: AlertProps;
  centered?: boolean;
  title?: ReactNode;
  text?: ReactNode;
  buttons?: ButtonProps[];
  customVariant?: ButtonProps['variant'];
};

export const GeneralView: FC<Props> = props => {
  const {
    title,
    text,
    buttons,
    centered,
    connectionTag,
    progressBar,
    alert,
    indicating,
    customVariant,
  } = props;

  if (indicating) {
    return (
      <div className="py-10 text-center text-marine-40">
        <LoadingSpinner size="lg" className="inline-block" />
      </div>
    );
  }

  return (
    <DialogBody>
      {connectionTag && <div className="mx-auto">{connectionTag}</div>}

      <HeaderSection headline={title} subline={text} centered={centered} />

      {progressBar}

      {alert && <Alert {...alert} />}

      {buttons && buttons.length > 0 && (
        <ButtonGroup
          orientation={centered ? 'horizontal-center' : 'horizontal'}
        >
          {buttons.map((button, idx) => (
            <Button
              key={idx}
              {...button}
              variant={customVariant ?? button.variant}
            />
          ))}
        </ButtonGroup>
      )}
    </DialogBody>
  );
};
